import { LoadMode } from "./index49.js";
import { getNextThread } from "./index52.js";
import { getForecastedThread } from "./index57.js";
import { threadToPolyOffset } from "./index58.js";
import { V3toVector3, Vector3toV3, differencePolygons, getPolygonArea, isPointInside, polyIntersectsConvexPoly } from "@project-rouge/rg-three";
import { dequal } from "dequal";
var branchProbability = .5;
function addThreadsToPolys({ plotContextList, loadMode, frozenThreads, unboundedTailor }) {
	const boundaries = plotContextList.map((plot) => plot.poly);
	const threads = [];
	const mainThreads = [];
	trimFrozenThreads(plotContextList, frozenThreads);
	const dataToController = /* @__PURE__ */ new Map();
	for (let i = 0; i < plotContextList.length; i++) {
		const plotContext = plotContextList[i];
		let tryTrimStart = true;
		if (plotContext.context.rng) tryTrimStart = plotContext.context.rng() > .5;
		const thread = getForecastedThread({
			context: plotContext.context,
			boundary: plotContext.poly,
			holes: plotContext.holes,
			loadMode,
			plotIndex: i,
			tryTrimStart
		});
		mainThreads.push(thread);
		if (!thread) continue;
		threads.push(thread);
		dataToController.set(thread.data, thread);
		trimPolys(boundaries, thread.data);
	}
	const branchableMainThreads = threads.slice();
	for (const thread of mainThreads) {
		if (!thread) continue;
		const rng = thread.context.rng;
		if (unboundedTailor && rng && rng() < branchProbability) continue;
		const nextThread = getNextThread(thread, thread.context.avoidNorthFactor < 1 ? LoadMode.double : loadMode);
		if (!nextThread) {
			branchableMainThreads.splice(branchableMainThreads.indexOf(thread), 1);
			continue;
		}
		thread.save(nextThread);
		threads.push(nextThread.thread);
		dataToController.set(nextThread.thread.data, nextThread.thread);
		trimPolys(boundaries, nextThread.thread.data);
	}
	for (const thread of mainThreads) {
		if (!thread) continue;
		const rng = thread.context.rng;
		if (unboundedTailor && rng && rng() < branchProbability) continue;
		const branchLoadMode = thread.context.avoidNorthFactor < 1 ? LoadMode.double : loadMode;
		const threadOptions = [];
		if (branchableMainThreads.includes(thread)) {
			const nextThreadA = getNextThread(thread, branchLoadMode);
			if (nextThreadA) threadOptions.push(nextThreadA);
		}
		const branchThread = thread.data.startThread || thread.data.endThread;
		if (branchThread) {
			const nextThreadB = getNextThread(dataToController.get(branchThread.thread), branchLoadMode);
			if (nextThreadB) threadOptions.push(nextThreadB);
		}
		if (threadOptions.length === 0) continue;
		threadOptions.sort((a, b) => b.thread.data.size - a.thread.data.size);
		const bestNextThread = threadOptions[0];
		dataToController.get(bestNextThread.thread.data.startThread.thread).save(bestNextThread);
		threads.push(bestNextThread.thread);
		trimPolys(boundaries, bestNextThread.thread.data);
	}
	for (const thread of threads) thread.data.snapToGrid();
	return {
		threads,
		mainThreads
	};
}
function trimFrozenThreads(dataList, frozenThreads) {
	const threadsPolys = frozenThreads.map((t) => threadToPolyOffset(t).map(Vector3toV3));
	for (const data of dataList) {
		const originalPolyA = data.poly.map(Vector3toV3);
		let polyA = originalPolyA;
		for (const polyB of threadsPolys) {
			if (!polyA.length) break;
			const intersects = polyIntersectsConvexPoly(polyA, polyB);
			const polyACopy = polyA;
			if (intersects) polyA = trimThreadPoly(polyA, polyB);
			if (!dequal(polyA, polyACopy)) continue;
			if (!isPointInside(polyB[0], polyA)) continue;
			data.holes.push(polyB.map(V3toVector3));
		}
		if (polyA === originalPolyA) continue;
		data.poly.length = 0;
		data.poly.push(...polyA.map(V3toVector3));
	}
}
function trimPolys(boundaries, thread) {
	const threadPoly = threadToPolyOffset(thread).map(Vector3toV3);
	const skip = boundaries.indexOf(thread.boundary);
	for (let i = 0; i < boundaries.length; i++) {
		if (i === skip) continue;
		const polyV3 = boundaries[i].map(Vector3toV3);
		if (!polyIntersectsConvexPoly(polyV3, threadPoly)) continue;
		const trimmedPoly = trimThreadPoly(polyV3, threadPoly);
		boundaries[i].length = 0;
		boundaries[i].push(...trimmedPoly.map(V3toVector3));
	}
}
function trimThreadPoly(poly, threadPoly) {
	const diffPolys = differencePolygons(poly, [threadPoly]);
	if (!diffPolys.length) return [];
	let biggestPoly = diffPolys[0];
	let biggestArea = -Infinity;
	for (const diffPoly of diffPolys) {
		const polyArea = getPolygonArea(diffPoly);
		if (polyArea <= biggestArea) continue;
		biggestPoly = diffPoly;
		biggestArea = polyArea;
	}
	return biggestPoly;
}
export { addThreadsToPolys };

//# sourceMappingURL=index59.js.map